exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-height:720px){#modal-body{height:400px;overflow:auto}}@media(max-height:820px){#modal-body{height:400px;overflow:auto}}@media(max-height:400px){#modal-body{height:140px;overflow:auto}}.closes{color:#6979ef;font-size:28px;font-weight:700;margin-left:auto;display:flex}.closes:focus,.closes:hover{color:#000;text-decoration:none;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b0d0774","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/kontak/KontakBaruLite.vue
// module id = 258
// module chunks = 0